import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import Phone from './Phone'
import ShortText from './ShortText'
import DropDown from './DropDown'
import LongText from './LongText'
import FileUpload from './FileUpload'

const AerospaceEngineerApplicationForm = () => {


  const educationData = [
    'دبیرستان',
    'مدرک کاردانی',
    'مدرک لیسانس',
    'مدرک کارشناسی ارشد',
    'دکترا'
  ]


  return (
    <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
      <Heading header={'فرم درخواست مهندس هوافضا'} subHeader={'لطفاً فرم درخواست را برای درخواست موقعیت مهندس هوافضا پر کنید.'} />
      <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
        <FullName header={'نام و نام خانوادگی'} />
        <Email header={'آدرس ایمیل'} />
        <Phone header={'شماره تلفن'} />
        <ShortText header={'آدرس پروفایل لینکدین'} />
        <DropDown header={'بالاترین سطح تحصیلات'} options={educationData} />
        <LongText header={'مهارت‌های فنی'} />
        <FileUpload header={'رزومه خود را آپلود کنید'} />
        <LongText header={'نامه همراه رزومه'} />
      </Grid>
    </Grid>
  )
}

export default AerospaceEngineerApplicationForm
